<div class="text-center text-secondary font-italic">
    <ion-spinner *ngIf="searching" class="mt-4"></ion-spinner>
    <p *ngIf="!searching && searchAttempted && !facilities.length" class="mt-4">No results found</p>
</div>
<ion-list class="mt-2" *ngIf="facilities.length">
    <ion-card
        *ngFor="let facility of facilities"
        detail="false"
        (click)="selectFacility(facility)"
    >
        <ion-grid>
            <ion-row class="align-items-center pl-3 py-3">
                <ion-col>
                    <div class="title">{{ facility.Name }}</div>
                    <div class="subtitle" *ngIf="facility.Address">{{ facility.Address.Address1 }}</div>
                    <div *ngIf="facility.Address && facility.Address.Address2">{{ facility.Address.Address2 }}</div>
                    <div class="subtitle" *ngIf="facility.Address">
                        {{ facility.Address.City }},
                        <span *ngIf="facility.Address.StateProvinceAbbreviation">{{ facility.Address.StateProvinceAbbreviation }} </span>
                        {{ facility.Address.ZipPostalCode }}
                        <span *ngIf="!facility.Address.StateProvinceAbbreviation">{{ facility.Address.CountryName }} </span>
                    </div>
                    <ion-text color="primary" class="select-subfacility" *ngIf="facility.FacilityType === FacilityType.Parent">Select Subfacility</ion-text>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card>
</ion-list>
